import { EmberRoute } from '../../../../../enums/emberRoute'
import { reactRoute } from '../../../../../utils/routing/reactRoute'
import { MenuNavItemValue } from '../types/menuNavItem'

const routeToAction: Partial<Record<string, string>> = {
  [EmberRoute.InvoicesNew]: 'create new invoice',
  [reactRoute.organization.bills.getNewBillRoute()]: 'create new bill',
  [EmberRoute.QuotesNew]: 'create new quote',
}

export const getFastMenuEventActionFromRoute = (routeTo: MenuNavItemValue) => {
  return routeTo && routeToAction[routeTo]
}
